import React, { forwardRef } from 'react';
import * as PortalPrimitive from '@radix-ui/react-portal';

export default forwardRef<
  HTMLDivElement,
  React.PropsWithChildren<PortalPrimitive.PortalProps>
>(function Portal({ ...props }, forwardedRef) {
  return <PortalPrimitive.Root {...props} ref={forwardedRef} />;
});
